import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { type PlacementCandidateBan } from "../api/useGetPlacementCandidateBan";
import { getPlacementsRootPath } from "../paths";

export enum BanDisputeStep {
  REASON = 1,
  DETAILS = 2,
  CONFIRMATION = 3,
}

interface UseDisputeBanStepsParams {
  ban?: PlacementCandidateBan;
  isLoadingBan: boolean;
}

export function useDisputeBanSteps(params: UseDisputeBanStepsParams) {
  const { ban, isLoadingBan } = params;

  const history = useHistory();

  const [currentStep, setCurrentStep] = useState<BanDisputeStep | undefined>(undefined);

  const isDisputed = isDefined(ban?.dispute);
  const placementsRootPath = getPlacementsRootPath({});

  useEffect(() => {
    if (!isLoadingBan && ban && currentStep === undefined) {
      setCurrentStep(isDisputed ? BanDisputeStep.CONFIRMATION : BanDisputeStep.REASON);
    }
  }, [isLoadingBan, ban, isDisputed, currentStep]);

  const handleBack = () => {
    if (currentStep === undefined) {
      return;
    }

    const backActions: Record<BanDisputeStep, () => void> = {
      [BanDisputeStep.REASON]: () => {
        logEvent(APP_V2_APP_EVENTS.DISPUTE_BAN_CLOSED, { banId: ban?.id });
        history.replace(placementsRootPath);
      },
      [BanDisputeStep.DETAILS]: () => {
        setCurrentStep(BanDisputeStep.REASON);
      },
      [BanDisputeStep.CONFIRMATION]: () => {
        history.replace(placementsRootPath);
      },
    };

    backActions[currentStep]();
  };

  return {
    currentStep,
    setCurrentStep,
    handleBack,
  };
}
